import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

const trim = (cv) => {
  const ctx = cv.getContext("2d");
  const { data, width, height } = ctx.getImageData(0, 0, cv.width, cv.height);
  let x0 = width, y0 = height, x1 = -1, y1 = -1;
  for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) {
    if (data[(y * width + x) * 4 + 3] > 10) { x0 = Math.min(x0, x); y0 = Math.min(y0, y); x1 = Math.max(x1, x); y1 = Math.max(y1, y); }
  }
  if (x1 < 0) return null;
  const out = document.createElement("canvas");
  out.width = x1 - x0 + 16; out.height = y1 - y0 + 16;
  out.getContext("2d").drawImage(cv, x0 - 8, y0 - 8, out.width, out.height, 0, 0, out.width, out.height);
  return out.toDataURL("image/png");
};

export default function AISignaturePad({ onChange }) {
  const cv = useRef(null);
  const last = useRef(null);
  const [empty, setEmpty] = useState(true);
  useEffect(() => {
    const ctx = cv.current.getContext("2d");
    ctx.lineWidth = 5; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0f1f5c";
  }, []);
  const pos = (e) => {
    const r = cv.current.getBoundingClientRect();
    return [(e.clientX - r.left) * (cv.current.width / r.width), (e.clientY - r.top) * (cv.current.height / r.height)];
  };
  const down = (e) => { e.preventDefault(); cv.current.setPointerCapture?.(e.pointerId); last.current = pos(e); };
  const move = (e) => {
    if (!last.current) return;
    const ctx = cv.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath(); ctx.moveTo(...last.current); ctx.lineTo(...p); ctx.stroke();
    last.current = p;
    if (empty) setEmpty(false);
  };
  const up = () => { if (last.current) { last.current = null; onChange(trim(cv.current)); } };
  const clear = () => { cv.current.getContext("2d").clearRect(0, 0, cv.current.width, cv.current.height); setEmpty(true); onChange(null); };
  return (
    <div className="relative">
      <canvas ref={cv} width={640} height={240} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up}
        className="w-full h-[120px] rounded-xl border-2 border-dashed border-slate-200 bg-white touch-none cursor-crosshair" data-testid="ai-signature-pad" />
      {empty && <span className="absolute inset-0 grid place-items-center text-[12px] text-slate-300 pointer-events-none">Tandatangan di sini dengan jari / tetikus</span>}
      <button type="button" onClick={clear} className="absolute top-1.5 right-1.5 h-7 px-2 rounded-lg bg-white/90 border border-slate-200 text-[11px] text-slate-500 inline-flex items-center gap-1" data-testid="ai-signature-clear"><Eraser className="h-3 w-3" />Padam</button>
    </div>
  );
}
